import { useEffect } from 'react';
import { X } from 'lucide-react';

// iOS presentation sheet: slides up from bottom, rounded top corners,
// dimmed backdrop, grabber handle. detent: 'medium' (~50%) | 'large' (~90%) | 'full'
export default function Sheet({ open, onClose, detent = 'large', title = '', children }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const heights = { medium: 'max-h-[55%]', large: 'max-h-[88%]', full: 'h-[94%]' };

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/40 transition-opacity"
        onClick={onClose}
      />
      <div
        className={`absolute bottom-0 inset-x-0 mx-auto max-w-lg bg-[#F2F2F7] rounded-t-2xl shadow-2xl flex flex-col ${heights[detent]} animate-[slideUp_0.25s_ease-out]`}
        role="dialog"
      >
        <div className="pt-2 pb-1 flex justify-center shrink-0">
          <div className="w-9 h-1.5 rounded-full bg-gray-300" />
        </div>
        {(title || onClose) && (
          <div className="relative flex items-center justify-center px-4 pb-2 shrink-0">
            {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
            {onClose && (
              <button
                onClick={onClose}
                className="absolute right-4 w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center"
                aria-label="Close"
              >
                <X size={16} className="text-gray-600" />
              </button>
            )}
          </div>
        )}
        <div className="flex-1 overflow-y-auto no-scrollbar">{children}</div>
      </div>
    </div>
  );
}
